/*
 * @Author: WeijianXu weijian.xu@unidt.com
 * @Date: 2024-04-30 15:25:15
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-06-24 18:22:09
 * @FilePath: \intelligent-knowledge-qa-pcd:\app\reps\ai-qa\assistant_portal_web\src\config\router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/*
 * @Author: WeijianXu weijian.xu@unidt.com
 * @Date: 2024-04-04 19:29:29
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-05-13 11:33:46
 * @FilePath: \intelligent-knowledge-qa-pcd:\app\reps\ai-qa\assistant_portal_web\src\config\router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import storeMenu from './storeMenu.js';
import applicationRoutes from './routes/application';
import aiLegalRoutes from './routes/ai-legal';
import cuserRoutes from './routes/cuser.js';

export const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      title: '首页',
    },
    component: () => import('@/components/frame/index.vue'),
    redirect: '/home',
    children: [
      // 应用相关路由
      {
        path: 'portal',
        name: 'portal',
        component: () => import('@/components/frame/EmptyRouter.vue'),
        redirect: '/portal/application',
        children: applicationRoutes,
        meta: {
          title: '应用',
        },
      },
    ],
  },
  {
    path: '/home',
    name: 'portal-home',
    component: () => import('@/views/Common/PortalIndex.vue'),
    meta: {
      title: '首页',
      public: true,
    },
  },
  {
    path: '/ai-legal',
    component: () => import('@/views/ai-legal/router.vue'),
    redirect: '/ai-legal/chat',
    children: [...aiLegalRoutes],
  },
  {
    path: '/displayPage',
    name: 'displayPage',
    component: () => import('@/views/Common/Home.vue'),
    meta: {
      title: '展示页',
      public: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Common/Login.vue'),
    meta: {
      public: true,
    },
  },
  {
    path: '/homeLogin',
    name: 'homeLogin',
    component: () => import('@/views/Common/HomeLogin.vue'),
    meta: {
      public: true,
    },
  },
  {
    path: '/lawauth',
    name: 'authentication',
    component: () => import('@/views/Common/HomeLogin.vue'),
    meta: {
      public: true,
    },
  },
  ...cuserRoutes,
  {
    path: '/:pathMatch(.*)',
    redirect: '404',
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/Common/404.vue'),
    meta: {
      public: true,
    },
  },
];

export const afterEach = (to) => {
  const StoreMenu = storeMenu();
  let breadcrumb = null;
  /* StoreMenu.options.forEach((e) => {
    if (e.children) {
      e.children.forEach((E) => {
        if (E.name == to.name) {
          breadcrumb = [{ ...e }, { ...E }];
        }
      });
    } else {
      if (e.name == to.name) {
        breadcrumb = [{ ...e }];
      }
    }
  }); */
  // 不是权限路由；固定路由、默认路由等
  if (!breadcrumb) {
    breadcrumb = [];
    to.matched.forEach((e) => {
      breadcrumb.push({ name: e.name, path: e.path, title: e.meta.title || e.name });
      StoreMenu.breadcrumb = breadcrumb;
    });
  }
  StoreMenu.breadcrumb = breadcrumb;
};
